(function () {
  const DEFAULT_THRESHOLD = 5;;

  function chipGroups(scope) {
    const chips = Array.from(scope.querySelectorAll('[data-option-value]'));
    const groups = new Map();
    chips.forEach((chip) => {
      const container =
        chip.closest('fieldset') ||
        chip.closest('[class*="option"]') ||
        chip.parentElement;
      if (!groups.has(container)) groups.set(container, []);
      groups.get(container).push(chip);
    });
    return Array.from(groups.values());
  }

  function isSelected(chip) {
    return (
      chip.getAttribute('aria-checked') === 'true' ||
      chip.getAttribute('aria-selected') === 'true' ||
      chip.dataset.selected === 'true' ||
      chip.classList.contains('is-selected') ||
      chip.classList.contains('selected') ||
      chip.classList.contains('active') ||
      chip.hasAttribute('data-active')
    );
  }

  function setup(scope) {
    const dataEl = scope.querySelector('[data-variant-inventory]');
    if (!dataEl) return;

    let variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const threshold = parseInt(dataEl.dataset.threshold, 10);
    const limit = isNaN(threshold) ? DEFAULT_THRESHOLD : threshold;
    if (limit <= 0) return;

    let busy = false;

    function render() {
      const groups = chipGroups(scope);
      if (!groups.length) return;

      const current = groups.map((g) => {
        const sel = g.find(isSelected);
        return sel ? sel.dataset.optionValue : null;
      });

      busy = true;

      groups.forEach((group, gIndex) => {
        group.forEach((chip) => {
          chip.querySelectorAll('.stock-badge').forEach((n) => n.remove());

          const combo = current.slice();
          combo[gIndex] = chip.dataset.optionValue;

          const variant = variants.find((v) =>
            v.options.every((opt, i) => combo[i] == null || opt === combo[i])
          );

          if (!variant || !variant.tracked || !variant.available) return;
           if (variant.qty > 0 && variant.qty <= limit) {
            if (getComputedStyle(chip).position === 'static') {
              chip.style.position = 'relative';
            }
            const badge = document.createElement('span');
            badge.className = 'stock-badge';
            badge.textContent = variant.qty + ' left';
            chip.appendChild(badge);
          }
        });
      });

      requestAnimationFrame(() => {
        busy = false;
      });
    }

    render();

    scope.addEventListener('click', () => setTimeout(render, 50));
    scope.addEventListener('change', () => setTimeout(render, 50));

    new MutationObserver(() => {
      if (busy) return;
      requestAnimationFrame(render);
    }).observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-checked', 'aria-selected', 'data-selected'],
    });
  }

  function init() {
    const scopes = document.querySelectorAll('[data-section-type="product"]');
    (scopes.length ? scopes : [document]).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();